import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import PageHero from '../components/PageHero';
import ProgramCard from '../components/ProgramCard';
import { programs } from '../data/siteData';

const { FiArrowRight, FiMessageCircle, FiUsers, FiAward } = FiIcons;

function Programs() {
  return (
    <>
      <PageHero
        eyebrow="Programs"
        title="Practice today. Be ready tomorrow."
        text="Our programming connects practical instruction with participation, mentorship, and real-world expectations."
        image="/images/3.jpg"
      />

      <section className="programs-detail">
        {programs.map((program, index) => (
          <ProgramCard key={program.title} program={program} featured={index === 0} />
        ))}
      </section>

      <section className="camp-focus">
        <div className="camp-copy">
          <p className="eyebrow">Program spotlight</p>
          <h2>C.A.M.P. builds workplace readiness from the ground up.</h2>
          <p>The program introduces young adults to the fundamentals of employment expectations within restaurant and food-industry settings. Participants develop professional habits through approachable instruction, hands-on practice, and community connection.</p>
          <Link className="primary-button" to="/get-involved">
            Support C.A.M.P. <SafeIcon icon={FiArrowRight} />
          </Link>
        </div>

        <div className="learning-list">
          <div>
            <SafeIcon icon={FiMessageCircle} />
            <span><strong>Communicate</strong>Practice clear, respectful workplace interaction.</span>
          </div>
          <div>
            <SafeIcon icon={FiUsers} />
            <span><strong>Collaborate</strong>Understand teamwork, reliability, and shared goals.</span>
          </div>
          <div>
            <SafeIcon icon={FiAward} />
            <span><strong>Grow</strong>Build habits that support long-term employment.</span>
          </div>
        </div>
      </section>
    </>
  );
}

export default Programs;